<template>
<div>
  <div class="week-wrapper">
    <a href="https://www.infoq.cn/weekly/preview" target="_blank" @click="showSample">
      查看样刊
      <i class="iconfont">&#xe62f;</i>
    </a>
    <gkButton class="sub-button" color="blue" size="normal" @click="toWeeklyLanding">
      <span class="icon"></span> 订阅
    </gkButton>
  </div>
  <SubEmailModal :show="show" @close="closeModal" @changeSub="changeSub"/>
</div>
</template>

<script>
import gkButton from 'gkui/button'
import CustomSection from '../../components/layout/Section'
import SubEmailModal from '../../components/modal/SubEmailModal'

export default {
  name: 'home-week',
  components: {
    gkButton,
    CustomSection,
    SubEmailModal
  },
  props: {
    sub: {
      type: [Number, Boolean],
      default: false
    }
  },
  data () {
    return {
      isSub: !!this.sub,
      show: false
    }
  },
  computed: {
  },
  watch: {
    sub (val) {
      this.isSub = !!val
    }
  },
  created () {
  },
  methods: {
    toWeeklyLanding () {
      // this.$router.push('/weekly/landing')
      window.open('https://www.infoq.cn/weekly/landing')
    },
    showSample () {
      window.ga && window.ga('send', 'event', '每周精要样刊点击数', window.location.href)
    },
    showModal () {
      window.ga && window.ga('send', 'event', '每周精要订阅点击数', window.location.href)
      this.show = true
      // AccountService.getSigninInfo().then(res => {
      //   this.show = true
      // })
      // .catch(() => {
      //   utils.login()
      // })
    },
    closeModal () {
      this.show = false
    },
    changeSub (sub) {
      this.isSub = sub
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';

.week-wrapper {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 296px; height: 120px;
  padding: 15px 18px;
  background: url('../../assets/img/home-week.png') no-repeat;
  background-size: contain;

  & a {
    line-height: 26px;
    @include font(13);
    color: $blue;
    opacity: 0.6;

    &:hover {
      opacity: 1;
    }
  }

  & .iconfont {
    font-size: 12px;
  }

  & .sub-button {
    width: 70px;

    & .icon {
      position: relative;
      width: 11px; height: 11px;
      margin-right: 3px;

      &:before,
      &:after {
        content: ' ';
        display: block;
        position: absolute; left: 50%; top: 50%;
        background: #FFF;
      }

      &:before {
        width: 11px; height: 1px;
        margin-left: -6px;
      }

      &:after {
        width: 1px; height: 11px;
        margin: -5px 0 0 -1px;
      }
    }
  }
}

.week-modal ::v-deep .content {
  padding: 50px;
}

.desc {
  margin: 35px 0;
  @extend %font12;
  text-align: center;
  color: $lightBlack;
}
.sub-btn {
  width: 137px; height: 37px;
}

.input {
  width: 100%;
  padding: 14px 0;
  @include lineFont(16);
  text-align: left;
  border: none;
  border-bottom: 1px solid $borderGray;

  &[disabled] {
    user-select: none;
    cursor: not-allowed;
  }
}
.email-wrap {
  position: relative;
  margin-bottom: 20px;
  
  & .success {
    position: absolute; top: -10px; left: 0;
    height: 20px;
    color: #17B04B;
    @extend %font12;
  }
}

.captcha-wrap {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  margin-bottom: 15px;
  border-bottom: 1px solid $borderGray;

  & .captcha-input {
    position: relative;
    flex: 1;

    & input {
      width: 100%;
      @include lineFont(16);
      background:transparent;
      border: 0;
      outline: none;

      &[disabled] {
        user-select: none;
        cursor: not-allowed;
      }
    }

    & .error {
      position: absolute; z-index: 100; left: 0; bottom: -27px;
    }
  }
  
  & .captcha {
    width: 100px; height: 100%;
    cursor: pointer;

    & img {
      width: 100%; height: 100%;
    }
  }
}

.code-wrap {
  position: relative;
  margin-bottom: 56px;

  & .code-btn {
    position:absolute; top: 0; right: 0;
    line-height: 53px;
    font-size: 14px;
    color: #1F6BB5;
    cursor: pointer;
    user-select: none;
  }

  & .sending {
    color: #8A8A8A;
    cursor: not-allowed;
    pointer-events: none;
  }
}
.captcha-input,
.email-wrap,
.code-wrap {
  & .error{
    line-height: 22px;
    @include font(12, 400);
    color: #ff3232;
  }
}
.email-wrap,
.code-wrap {
  & .error {
    position: absolute; z-index: 100; left:0; bottom: -20px;
  }
}


.result-container {
  height: 33px;

  & .error,
  & .tips {
    line-height: 22px;
    @include font(12, 400);
    text-align: center;
    color: #ff3232;
  }

  & .tips {
    line-height: 32px;
    @include font(14, 400);
    color: $blue;
  }
}
.sub-success {
  & .icon-success {
    width: 58px; height: 58px;
    margin: 65px auto 20px;

    & img {
      width: 100%; height: 100%;
    }
  }
  h3 {
    @include lineFont(16, 400);
    text-align: center;
  }
  p.desc {
    margin-top: 13px;
  }
}
</style>

 